// app/(lib)/actions/privacyPolicyAction.ts
"use server";

import { privacyPolicyService } from "../services/privacyPolicyService";
import { extractDomain } from "../utils/domain";

/**
 * Fetch privacy policy page content from API
 */
export async function getPrivacyPolicyDataAction(
  franchiseeId?: string | null,
  language?: string | null,
) {
  try {
    const domain = await extractDomain();

    const privacyPolicyData = await privacyPolicyService.fetchByDomain(domain, franchiseeId, language);

    return {
      success: true,
      data: privacyPolicyData,
    };
  } catch (error) {
    console.error("[getPrivacyPolicyDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
